import { __rest } from 'tslib';
import { t } from '../../i18n.es.js';
import { styled, Button, LazyImage, Link } from '@teko/ui';
import React from 'react';

const Wrapper = styled.div `
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
`;
const Description = styled.div `
  color: #848788;
  margin-top: 16px;
  margin-bottom: 24px;
`;
const StyledButton = styled(Button) `
  :hover {
    color: #fff;
  }
`;
const EmptyCartPanel = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(LazyImage, { src: "https://i.imgur.com/Drj57qu.png" }),
        React.createElement(Description, null, t('Giỏ hàng chưa có sản phẩm nào')),
        React.createElement(Link, { href: "/", passHref: true },
            React.createElement(StyledButton, { tag: "a", variant: "primary" }, t('Mua sắm ngay')))));
};

export { EmptyCartPanel };
